import { render, staticRenderFns } from "./TextColor.vue?vue&type=template&id=0331b159"
import script from "./TextColor.vue?vue&type=script&lang=js"
export * from "./TextColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports